export enum LessonPlanActionType {
  AddSkippedDay = 'AddSkippedDay',
  RemoveSkippedDay = 'RemoveSkippedDay',
  AddStretchedLesson = 'AddStretchedLesson',
  ReduceStretchedLesson = 'ReduceStretchedLesson',
  ChangeLessonDate = 'ChangeLessonDate',
}

export enum LessonSectionApiType {
  Tab = 'Tab',
  LessonBox = 'LessonBox',
}

// The real section type.
export enum LessonSectionType  {
  Section = 'Section',
  SubSection = 'SubSection',
}

export enum LessonStepType {
  Thumbs = 'Thumbs',
  EBook = 'EBook',
  Step = 'Step',
}
